<template>
  <el-radio v-bind="$attrs"> <slot /> </el-radio>
</template>

<script>
export default {
  name: 'RtRadio'
};
</script>

<style></style>



// WEBPACK FOOTER //
// rtRadio.vue?362a3eaa